import { render, staticRenderFns } from "./DoKoCardBlanko.vue?vue&type=template&id=676f6cf4&"
import script from "./DoKoCardBlanko.vue?vue&type=script&lang=ts&"
export * from "./DoKoCardBlanko.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports